import { render, staticRenderFns } from "./jmOrderList2022.vue?vue&type=template&id=1883129e&scoped=true&"
import script from "./jmOrderList2022.vue?vue&type=script&lang=js&"
export * from "./jmOrderList2022.vue?vue&type=script&lang=js&"
import style0 from "./jmOrderList2022.vue?vue&type=style&index=0&id=1883129e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1883129e",
  null
  
)

export default component.exports